"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MultiColumnItemComponent = void 0;
exports.default = MultiColumnItem;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = require("@linaria/react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = _interopRequireDefault(require("react"));
var _image = require("@site/pattern-library-core/image");
var _card = _interopRequireDefault(require("../card"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
const widths = {
  figure: '200px',
  illustration: '217px',
  full: '100%'
};
const MultiColumnItemComponent = exports.MultiColumnItemComponent = /*#__PURE__*/(0, _react.styled)("div")({
  name: "MultiColumnItemComponent",
  class: "pl-mg7zceg",
  vars: {
    "mg7zceg-0": [({
      rounded
    }) => rounded === true ? _intents.default.ux.box.borderRadius : 'unset'],
    "mg7zceg-1": [({
      textAlign
    }) => textAlign === 'center' ? textAlign : `flex-${textAlign}`],
    "mg7zceg-2": [({
      gridSettings
    }) => `sp-${gridSettings.row}`],
    "mg7zceg-3": [({
      gridSettings
    }) => `sp2-${gridSettings.row}`],
    "mg7zceg-5": [({
      textAlign
    }) => textAlign],
    "mg7zceg-6": [({
      gridlines
    }) => gridlines ? `solid ${_intents.default.ux.box.borderColor}` : 'none'],
    "mg7zceg-7": [({
      gridSettings
    }) => `${gridSettings.tabletRowStart}/${gridSettings.tabletRowEnd}`],
    "mg7zceg-8": [({
      gridSettings
    }) => `${gridSettings.tabletColumn}`],
    "mg7zceg-9": [({
      backgroundColor
    }) => `${backgroundColor}`],
    "mg7zceg-11": [({
      gridSettings
    }) => `im-${gridSettings.tabletRow}`],
    "mg7zceg-12": [({
      noPadding
    }) => noPadding ? '0' : 'calc(2vw + 0.5rem)'],
    "mg7zceg-13": [({
      textAlign
    }) => textAlign === 'center' ? 'auto' : 'initial'],
    "mg7zceg-14": [({
      gridSettings
    }) => `tg-${gridSettings.tabletRow}`],
    "mg7zceg-15": [({
      textAlign
    }) => textAlign === 'center' ? 'auto' : 'calc(2vw + 0.5rem)'],
    "mg7zceg-16": [({
      gridSettings
    }) => `eb-${gridSettings.tabletRow}`],
    "mg7zceg-17": [({
      gridSettings
    }) => `hl-${gridSettings.tabletRow}`],
    "mg7zceg-18": [({
      gridSettings
    }) => `ds-${gridSettings.tabletRow}`],
    "mg7zceg-19": [({
      gridSettings
    }) => `pl-${gridSettings.tabletRow}`],
    "mg7zceg-20": [({
      gridSettings
    }) => `cs-${gridSettings.tabletRow}`],
    "mg7zceg-21": [({
      gridSettings
    }) => `di-${gridSettings.tabletRow}`],
    "mg7zceg-23": [({
      gridSettings
    }) => `${gridSettings.rowStart}/${gridSettings.rowEnd}`],
    "mg7zceg-24": [({
      gridSettings
    }) => `${gridSettings.column}`],
    "mg7zceg-26": [({
      gridSettings
    }) => `im-${gridSettings.row}`],
    "mg7zceg-27": [({
      gridSettings
    }) => `tg-${gridSettings.row}`],
    "mg7zceg-28": [({
      gridSettings
    }) => `eb-${gridSettings.row}`],
    "mg7zceg-29": [({
      gridSettings
    }) => `hl-${gridSettings.row}`],
    "mg7zceg-30": [({
      gridSettings
    }) => `ad-${gridSettings.row}`],
    "mg7zceg-31": [({
      gridSettings
    }) => `hls-${gridSettings.row}`],
    "mg7zceg-32": [({
      gridSettings
    }) => `ds-${gridSettings.row}`],
    "mg7zceg-33": [({
      gridSettings
    }) => `pl-${gridSettings.row}`],
    "mg7zceg-34": [({
      gridSettings
    }) => `cs-${gridSettings.row}`],
    "mg7zceg-35": [({
      gridSettings
    }) => `di-${gridSettings.row}`]
  }
});
const CardImg = /*#__PURE__*/(0, _react.styled)(_image.LazyImage)({
  name: "CardImg",
  class: "pl-c1gsq3bh",
  vars: {
    "c1gsq3bh-0": [({
      imgType
    }) => widths[imgType]],
    "c1gsq3bh-1": [({
      imgType
    }) => imgType === 'full' ? 'unset' : `${_patternLibraryUtils.density['8']} ${_patternLibraryUtils.density['8']} 0 !important`],
    "c1gsq3bh-2": [({
      imgType,
      rounded
    }) => {
      return imgType === 'full' && !rounded ? `unset` : _intents.default.ux.box.borderRadius;
    }]
  }
});

/**
 * @ignore @typedef {import('csstype').Property.TextAlign} TextAlign
 */
/**
 * Render column card with content alignment.
 * @module MultiColumnItem
 *
 * @param {Object} props React props
 * @param {string} props.id Id string
 * @param {Object} props.card Card text
 * @param {Object} props.image Image object
 * @param {string} props.imgType Type of Image
 * @param {string} props.textAlign Aligns the image and content
 * @param {boolean} props.indented Indents cards
 * @param {boolean} props.rounded Round edges of the card when 'full' imgType is used
 * @param {string} props.backgroundColor Item background color
 * @param {Object} props.ctas Ctas
 * @param {Object} props.priceLockup Price Lockup
 * @returns {React.ReactElement} section element
 * @public
 */
function MultiColumnItem({
  id,
  card,
  image = {},
  imgType = 'figure',
  textAlign = 'start',
  indented = false,
  gridlines,
  rounded = false,
  noPadding,
  backgroundColor,
  gridSettings,
  priceLockup
}) {
  const cardProps = {
    headlineTag: 'h4',
    // default this for calculating card eyebrows
    indented: indented,
    textAlign: textAlign,
    rounded: rounded,
    backgroundColor: (0, _patternLibraryUtils.getBackgroundColor)(backgroundColor),
    ...card
  };
  const {
    url: imgSrc,
    altText,
    height,
    width
  } = image;
  return /*#__PURE__*/_react2.default.createElement(MultiColumnItemComponent, {
    id: `id-${id}`,
    "data-cy": "item",
    indented: indented,
    rounded: rounded,
    noPadding: noPadding,
    textAlign: textAlign,
    gridlines: gridlines,
    gridSettings: gridSettings,
    backgroundColor: (0, _patternLibraryUtils.getBackgroundColor)(backgroundColor)
  }, /*#__PURE__*/_react2.default.createElement("div", {
    "data-cy": "spacer",
    "aria-hidden": "true"
  }), imgSrc && /*#__PURE__*/_react2.default.createElement(CardImg, {
    "data-cy": "image",
    rounded: rounded,
    url: imgSrc,
    altText: altText,
    height: height,
    width: width,
    imgType: imgType
  }), /*#__PURE__*/_react2.default.createElement(_card.default, (0, _extends2.default)({
    eyebrowTag: "h3"
  }, cardProps, {
    textAlign: textAlign,
    priceLockup: priceLockup
  })), /*#__PURE__*/_react2.default.createElement("div", {
    "data-cy": "spacer",
    "aria-hidden": "true"
  }));
}
MultiColumnItem.propTypes = {
  id: _propTypes.default.string,
  padding: _propTypes.default.string,
  noPadding: _propTypes.default.bool,
  ..._card.default.propTypes,
  image: _propTypes.default.object,
  imgType: _propTypes.default.oneOf(['figure', 'illustration', 'full']),
  textAlign: _propTypes.default.oneOf(['start', 'center']),
  gridlines: _propTypes.default.bool,
  indented: _propTypes.default.bool,
  rounded: _propTypes.default.bool,
  backgroundColor: _propTypes.default.oneOfType([_propTypes.default.shape({
    rgb: _propTypes.default.string,
    contrastRgb: _propTypes.default.string
  }), _propTypes.default.shape({
    intent: _propTypes.default.string
  })]),
  priceLockup: _propTypes.default.object
};